import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  FirstName: Yup.string().required('FirstName is required'),
  //   username: Yup.string()
  //     .required('Username is required')
  //     .min(6, 'Username must be at least 6 characters')
  //     .max(20, 'Username must not exceed 20 characters'),
  Email: Yup.string().required('Email is required').email('Email is invalid'),
  WorkEmail: Yup.string().nullable().transform((v) => (v === '' ? null : v)).email('Email-i i punës nuk është valid'),
  //   password: Yup.string()
  //     .required('Password is required')
  //     .min(6, 'Password must be at least 6 characters')
  //     .max(40, 'Password must not exceed 40 characters'),
  //   confirmPassword: Yup.string()
  //     .required('Confirm Password is required')
  //     .oneOf([Yup.ref('password'), null], 'Confirm Password does not match'),
  //   acceptTerms: Yup.bool().oneOf([true], 'Accept Terms is required'),
});

export default validationSchema;
